import {Panel, Root, SplitCol, SplitLayout, View} from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';
import React from 'react';
import {Game} from './panels/Game/Game';
import Home from './panels/Home/Home';
import MissionPanel from './panels/Missions/MissionPanel';
import Rating from './panels/Rating/Rating';
import TournamentPanel from './panels/Tournaments/TournamentPanel';
import {TournamentHistory} from './panels/TournamentHistory/TournamentHistory';
import {
    DEFAULT_VIEW,
    GAME_PANEL,
    HOME_PANEL,
    RATING_PANEL,
    TOURNAMENT_HISTORY_PANEL,
    MISSIONS_PANEL,
    TOURNAMENTS_PANEL
} from "./routing/routing";
import {SnackbarContext} from "./context/SnackbarContext";
import {ToastContext} from "./context/ToastContext";
import {useAppNavigation} from "./hooks/useAppNavigation";
import {useSnackbarProvider} from "./hooks/useSnackbarProvider";
import {useToastProvider} from "./hooks/useToastProvider";
import {Modals} from "./modals/Modals";

function App() {
    const { routeNavigator, activeView, activeModal, activePanel } = useAppNavigation();
    const { snackbar, snackbarContext } = useSnackbarProvider();
    const { toast, toastContext } = useToastProvider();

    return (
        <SnackbarContext.Provider value={snackbarContext}>
            <ToastContext.Provider value={toastContext}>
                <SplitLayout modal={<Modals activeModal={activeModal} routeNavigator={routeNavigator} />}>
                    <SplitCol>
                        <Root activeView={activeView}>
                            <View nav={DEFAULT_VIEW} activePanel={activePanel} onSwipeBack={() => routeNavigator.back()}>
                                <Panel nav={HOME_PANEL}><Home/></Panel>
                                <Panel nav={MISSIONS_PANEL}><MissionPanel/></Panel>
                                <Panel nav={TOURNAMENTS_PANEL}><TournamentPanel/></Panel>
                                <Panel nav={GAME_PANEL}><Game/></Panel>
                                <Panel nav={RATING_PANEL}><Rating/></Panel>
                                <Panel nav={TOURNAMENT_HISTORY_PANEL}><TournamentHistory/></Panel>
                            </View>
                        </Root>
                        {snackbar}
                        {toast}
                    </SplitCol>
                </SplitLayout>
            </ToastContext.Provider>
        </SnackbarContext.Provider>
    );
}

export default App;
